// extracted by mini-css-extract-plugin
export default {"titleContainer":"Title_titleContainer__OQ0Pf","title":"Title_title__YP+gA","deliveryDate":"Title_deliveryDate__3QfKz"};